export const getEnvironment = (): string | undefined => process.env.REACT_APP_STAGE;
